import { Grid, List, Typography } from "@material-ui/core";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import { Split } from "../../utils/Split";
import ProjectImg from "../../assets/img/project.jpg";
import ProjectImg2 from "../../assets/img/project2.jpg";
import UserTableHeader from "./TableHeader";
import ListProjects from "./ListProjects";
import ListCounters from "./ListCounters";
import ConsumptionChart from "./ConsumptionChart";
import ConsumptionsTable from "./ConsumptionTable";

const Details = (props) => {
  const userId = props.data.match.params.userId;
  const image = userId % 2 === 0 ? ProjectImg : ProjectImg2;
  return (
    <div
      style={{
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
      }}
    >
      <UserTableHeader image={image} userId={userId} />
      <div>
        <ListProjects userId={userId} />
      </div>
      <div>
        <ListCounters userId={userId} />
      </div>
      <div>
        <ConsumptionChart userId={userId} />
      </div>
      <div style={{ marginBottom: "24px" }}>
        <ConsumptionsTable userId={userId} />
      </div>
    </div>
  );
};

export default Details;
